/*
 * @Author: your name
 * @Date: 2021-05-08 10:41:48
 * @LastEditTime: 2021-07-14 19:24:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \burgeon-project-logic\config\module\page\strategy.config.js
 */
export default () => ({
  CUS_ST_C_STORAGE_SOURCING_STRATEGY_TOB: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/ST_C_STORAGE_SOURCING_STRATEGY_TOB.vue'
    ),
    labelName: t('TOB寻源策略定义编辑')
  },
  CUS_SG_C_STORAGE_SOURCING_STRATEGY: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/SG_C_STORAGE_SOURCING_STRATEGY/index.vue'
    ),
    labelName: t('寻源策略编辑'),
  },
  SG_B_SHOP_DETAIL: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/shopCom.vue'
    ),
  },
  // 店铺条码锁库策略
  SG_B_SHOP_LOCK_DETAIL: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/goodsInfoDetails.vue'
    ),
  },
  // 策略平台-物流区域设置
  LOGISTICSAREA: {
    menuKey: 'ST_C_EXPRESS_AREA',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/logisticsStrategy/logisticsArea.vue'
    ),
    labelName: t('物流区域设置新增')
  },
  // 策略平台-仓库物流优先级方案(新增/详情)
  SETWAREHOUSELOGISTICS: {
    menuKey: 'ST_C_WAREHOUSE_LOGISTICS',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/setWarehouseLogistics/setWarehouseLogistics.vue'
    ),
    labelName: t('仓库物流优先级方案新增')
  },
  // 策略平台-快递赔付方案(新增/详情)
  COURIERPAY: {
    menuKey: 'ST_C_COMPENSATE',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/courierPay/courierPay.vue'
    ),
    labelName: t('快递赔付方案编辑')
  },
  ORDERAUTOCHECK: {
    menuKey: 'ST_C_AUTOCHECK',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/orderAutoCheck.vue'
    ),
    labelName: t('订单自动审核编辑')
  },
  SENDSINGLERULE: {
    menuKey: 'ST_C_SEND_RULE',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/sendSingleRule.vue'
    ),
    labelName: t('发货单派单规则')
  },
  WPHEMAILSEND: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/wphEmailSend.vue'
    ),
    labelName: t('唯品会预警通知')
  },
  SMSSTRATEGY: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/smsStrategy.vue'
    ),
  },
  ST_C_VIPCOM_PROJECT: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/scheduleAddOrEdit.vue'
    ),
    labelName: t('档期日程规划')
  },
  SCHEDULEADDOREDIT: {
    menuKey: 'ST_C_VIPCOM_PROJECT',
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/scheduleAddOrEdit.vue'
    ),
    labelName: t('档期日程规划')
  },
  ST_C_WAREHOUSE_LOGISTICS_SET: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/warehouseLogisticsAddOrEdit.vue'
    ),
    labelName: t('仓库物流设置')
  },
  ST_C_PRICE: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/commodityPriceAddOrEdit.vue'
    ),
    labelName: t('商品价格策略')
  },
  ST_C_LIVE_CAST_STRATEGY: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/liveParsingAddOrEdit.vue'
    ),
    labelName: t('直播解析策略')
  },
  ST_C_ORDER_WAREHOUSE: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/storehouseRule.vue'
    ),
    isList: true,
    labelName: t('分仓规则'),
  },
  ST_C_ASSIGN_LOGISTICS: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/storehouseRule.vue'
    ),
    isList: true,
    labelName: t('分物流规则'),
  },
  ST_C_SPECIAL_ASSIGN_LOGISTICS: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/specialLogistics.vue'
    ),
    isList: true,
    labelName: t('特殊物流方案'),
  },
  ST_C_DELIVERY_AREA: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/logisticsDistribute.vue'
    ),
    isList: true,
    labelName: t('物流派送范围'),
  },
  ST_C_HOLD_ORDER_STRATEGY: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/holdStrategyAddOrEdit.vue'
    ),
    isList: true,
    labelName: t('HOLD单策略')
  },
  ST_C_TMALL_EXCHANGE_ORDER: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/tmExchangeAddOrEdit.vue'
    ),
    labelName: t('天猫换货策略')
  },
  ST_C_AUTO_AUDIT: {
    component: () => import(
      /* webpackChunkName: 'StrategyCenterPage' */
      'allpages/strategyPlatform/auditOrderStrategy.vue'
    ),
    labelName: t('审单策略')
  }

});
